import { isNotEmpty } from '@doltech/utils/lib/text';
import { types as t } from 'mobx-state-tree';
import { nanoid } from 'nanoid';

import { AdminAbstractBlanks } from '../admin-abstract-blanks.store';
import { AdminBlankCorrectAnswerInstance } from '../CorrectOption/_extends/admin-blank-correct-answer.store';
import { AdminAbstractQuestionWithBlankCorrectAnswers } from './admin-abstract-q-with-blank-correct-answer.store';

export const Paragraph = AdminAbstractBlanks.named('Paragraph');

export const AdminAbstractQuestionWithParagraph =
  AdminAbstractQuestionWithBlankCorrectAnswers.named('AdminAbstractQuestionWithParagraph')
    .props({
      heading: t.maybeNull<any>(t.string),
      paragraph: t.maybeNull(Paragraph),
    })
    .actions((self) => ({
      init() {
        self.paragraph = generateParagraph();
      },
    }))
    .actions((self) => ({
      reIndexBlank() {
        self.paragraph.blanks.forEach((blank, index) => {
          blank.key = index;
        });
        self.correctAnswers.forEach((correctAnswer, index) => {
          correctAnswer.key = index;
        });
      },
      setHeading(heading: string) {
        self.heading = heading;
      },
    }))
    .views(function inheritedViews(self) {
      return {
        get isCompleted() {
          const isParagraphCompleted = self.paragraph.isCompleted;
          const isAllCorrectAnswersCompleted = self.correctAnswers.every(
            (correctAnswer: AdminBlankCorrectAnswerInstance) => correctAnswer.isCompleted,
          );
          const isTitleHasValue = isNotEmpty(self.heading);

          return isAllCorrectAnswersCompleted && isParagraphCompleted && isTitleHasValue;
        },
        get isDirty() {
          const isParagraphDirty = self.paragraph.isDirty;
          const isAtLeastOneCorrectAnswerDirty =
            self.correctAnswers.length > 0 &&
            self.correctAnswers.some(
              (correctAnswer: AdminBlankCorrectAnswerInstance) => correctAnswer.isDirty,
            );

          const isTitleHasValue = isNotEmpty(self.heading);

          return isAtLeastOneCorrectAnswerDirty || isParagraphDirty || isTitleHasValue;
        },
        preparePayloadForSubmit() {
          return {
            heading: self.heading,
            type: self.type,
            paragraph: self.paragraph,
            correctAnswers: self.correctAnswers.map((ca: any) => ({
              blankId: ca.blankId,
              key: ca.key,
              explanation: ca.explanation,
              value: ca.value,
            })),
          };
        },
        questionCount() {
          return Math.max(self.paragraph.range, 1);
        },
        get corrections() {
          return self.correctAnswers;
        },
        get explanationKeys() {
          return self.correctAnswers.map((correctAnswer: AdminBlankCorrectAnswerInstance) => ({
            key: correctAnswer.key,
            displayKey: correctAnswer.key + 1,
            answerValue: correctAnswer.value,
          }));
        },
      };
    });

export const generateParagraph = () => Paragraph.create({ id: nanoid() });

